export default "__VITE_ASSET__BXFm897C__"